import React from "react";
import EditTransactionForm from "../Components/EditTransactionForm.js";

function Edit() {
	return (
		<div>
			<EditTransactionForm />
		</div>
	);
}

export default Edit;
